import { useEffect, useRef, useState } from 'react';

export default function RegistrationHeader() {
  const [isVisible, setIsVisible] = useState(false);
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (headerRef.current) {
      observer.observe(headerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={headerRef} className="relative bg-gradient-to-r from-[#0D1B3E] via-[#1a2f5a] to-[#0D1B3E] text-white py-20 overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/7ac9a44bec626a0eea192eeb01cf2a69.jpg')] bg-cover bg-center opacity-15"></div>
      <div className="absolute inset-0 bg-black/30"></div>
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 border-2 border-[#C9A84C] rounded-full animate-float"></div>
        <div className="absolute bottom-10 right-20 w-24 h-24 border-2 border-[#1A9B8C] rounded-full animate-float-delay"></div>
        <div className="absolute top-1/2 right-1/3 w-16 h-16 border-2 border-white rounded-full animate-float"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div 
          className={`inline-flex items-center justify-center w-20 h-20 bg-[#C9A84C] rounded-full mb-6 transition-all duration-700 ${
            isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-50'
          }`}
          style={{ transitionDelay: '0ms' }}
        >
          <i className="ri-file-list-3-line text-3xl text-white"></i>
        </div>
        <h1 
          className={`text-5xl font-bold mb-4 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: '200ms' }}
        >
          Kongre Kayıt
        </h1>
        <p 
          className={`text-xl text-gray-200 max-w-3xl mx-auto leading-relaxed transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: '400ms' }}
        >
          Genç Diş Hekimliği Derneği 2. İstanbul Kongresi'ne kayıt olmak için aşağıdaki formu eksiksiz doldurunuz.
        </p>
        <div 
          className={`mt-8 flex items-center justify-center gap-6 text-sm transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: '600ms' }}
        >
          <div className="flex items-center gap-2">
            <i className="ri-calendar-line text-[#C9A84C] text-lg"></i>
            <span>2-3 Mayıs 2026</span>
          </div>
          <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
          <div className="flex items-center gap-2">
            <i className="ri-map-pin-line text-[#C9A84C] text-lg"></i>
            <span>İstanbul Kongre Merkezi, İstanbul</span>
          </div>
        </div>
      </div>
    </div>
  );
}